/**
 * ADOBE CONFIDENTIAL
 * __________________
 * Copyright 2023 Adobe
 * All Rights Reserved.
 * __________________
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 */

import { ProductModel } from '../models';

import { Product } from '../models/acdl-models';

export function transformProduct(product: ProductModel): Product {
  return {
    productId: Number(product?.externalId),
    name: product?.name,
    sku: product?.variantSku || product?.sku,
    topLevelSku: product?.sku,
    specialToDate: undefined,
    specialFromDate: undefined,
    newToDate: undefined,
    newFromDate: undefined,
    createdAt: undefined,
    updatedAt: undefined,
    manufacturer: undefined,
    countryOfManufacture: undefined,
    categories: undefined,
    productType: product?.productType,
    pricing: {
      regularPrice: product?.prices?.regular?.amount || 0,
      minimalPrice: product?.prices?.final?.minimumAmount,
      maximalPrice: product?.prices?.final?.maximumAmount,
      specialPrice: product?.prices?.final?.amount,
      tierPricing: undefined,
      currencyCode: product?.prices?.final?.currency || 'USD',
    },
    canonicalUrl: product?.url,
    mainImageUrl: product?.images?.[0]?.url,
  };
}
